import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import classnames from 'classnames';
import FollowingWatchIcon from '../FollowingWatch';
import CircleWrap from '../../CircleWrap';
import s from './EyeDisc2.scss';
const EyeDisc2 = (_param)=>{
    var { className } = _param, props = _object_without_properties(_param, [
        "className"
    ]);
    return /*#__PURE__*/ React.createElement(CircleWrap, {
        circleClassName: classnames(s['disc'], className),
        size: props.size
    }, /*#__PURE__*/ React.createElement(FollowingWatchIcon, _object_spread_props(_object_spread({}, props), {
        disableDefaultColors: true
    })));
};
EyeDisc2.displayName = 'EyeDisc2';
export default EyeDisc2;
